import React from 'react'
import { Link } from 'gatsby'
import styled from '@emotion/styled'
import PageTitle from '../components/PageTitle'
import Container from '../components/Container'
import Layout from '../components/Layout'
import SEO from '../components/SEO'

const Text = styled.p`
  text-align: center;
  line-height: 1.6;
  a {
    color: ${props => props.theme.colors.text};
  }
`

const NotFoundPage = () => (
  <Layout>
    <SEO title="404" description="Page Not Found" />
    <Container>
      <PageTitle>Page Not Found -<br/>요청하신 페이지를 찾을 수 없습니다.</PageTitle>
      <Text>
        상단의 메뉴 혹은 <Link to="/">홈페이지</Link>로 이동하시길 바랍니다.
      </Text>
    </Container>
  </Layout>
)

export default NotFoundPage
